/**
 * DADDL featured tabs — centered pack carousel (same math as video trust).
 * Viewport clips the track; neighbours peek at both edges.
 * Neighbour pack links centre that slide; only the focused pack opens the PDP.
 * Steer arrows sit in each card (stars/price row); panel click delegates go().
 * Grab / swipe is daddlBindCenteredLoop (daddl-carousel.js). No Swiper.
 */
(function () {
  'use strict';

  function stripCloneControls(slide) {
    slide.querySelectorAll('form').forEach(function (form) {
      form.setAttribute('aria-hidden', 'true');
      form.querySelectorAll('button, input, select, textarea').forEach(function (ctrl) {
        ctrl.disabled = true;
      });
    });
    slide.querySelectorAll('[data-daddl-ft-prev], [data-daddl-ft-next]').forEach(function (btn) {
      btn.disabled = true;
    });
  }

  function bindPanel(panel) {
    if (panel.daddlFtBound) return;
    if (typeof window.daddlBindCenteredLoop !== 'function') {
      document.addEventListener('DOMContentLoaded', function () { bindPanel(panel); });
      return;
    }

    var viewport = panel.querySelector('[data-daddl-ft-viewport]');
    var track = panel.querySelector('[data-daddl-ft-track]');
    if (!viewport || !track) return;

    panel.daddlFtBound = true;

    var loopCtl = window.daddlBindCenteredLoop({
      viewport: viewport,
      track: track,
      slideSelector: '[data-daddl-ft-slide]',
      cloneAttr: 'data-daddl-ft-clone',
      instantClass: 'is-instant',
      ignoreDown: '[data-daddl-ft-prev], [data-daddl-ft-next], [data-tilt-flip-btn]',
      prepareClone: stripCloneControls,
      onActive: function (index, slides) {
        slides.forEach(function (el, i) {
          var on = i === index;
          el.classList.toggle('is-active', on);
          var tilt = el.querySelector('daddl-pack-tilt');
          if (tilt && typeof tilt.setCarouselActive === 'function') {
            tilt.setCarouselActive(on);
          }
        });
      }
    });

    /* Neighbour packs are links — a tap should centre them, not open the PDP.
       Steer arrows live on every card; only the active row is clickable. */
    if (loopCtl) {
      panel.addEventListener('click', function (event) {
        if (event.target.closest('[data-daddl-ft-prev]')) {
          event.preventDefault();
          loopCtl.go(-1);
          return;
        }
        if (event.target.closest('[data-daddl-ft-next]')) {
          event.preventDefault();
          loopCtl.go(1);
        }
      });

      track.addEventListener('click', function (event) {
        var slide = event.target.closest('[data-daddl-ft-slide]');
        if (!slide || slide.classList.contains('is-active')) return;
        if (event.target.closest('[data-tilt-flip-btn]')) return;
        event.preventDefault();
        event.stopPropagation();
        var index = loopCtl.slides.indexOf(slide);
        if (index >= 0) loopCtl.goTo(index, true);
      }, true);
    }

    panel.daddlFtPosition = function (animate) {
      if (loopCtl) loopCtl.position(!!animate);
    };
  }

  class DaddlFeaturedTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = this.querySelectorAll('[data-daddl-ft-tab]');
      this.panels = this.querySelectorAll('[data-daddl-ft-panel]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
      });

      this.panels.forEach((panel) => {
        if (!panel.hidden) bindPanel(panel);
      });
    }

    activate(tab) {
      const id = tab.getAttribute('data-daddl-ft-tab');
      this.tabs.forEach((item) => {
        const on = item === tab;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const show = panel.getAttribute('data-daddl-ft-panel') === id;
        panel.hidden = !show;
        if (show) {
          bindPanel(panel);
          if (typeof panel.daddlFtPosition === 'function') panel.daddlFtPosition(false);
        }
      });
    }
  }

  if (!customElements.get('daddl-featured-tabs')) {
    customElements.define('daddl-featured-tabs', DaddlFeaturedTabs);
  }
})();
